import { createAPIService } from '@golden/getch';
import { addStartTime, addEndTime, parseServerTime } from './interceptors/ServerTime';
import { catchGDKError } from './interceptors/catchGDKError';
import { createAuthorization } from './interceptors/Authorization';
import { addSignature } from './interceptors/Signature';
import { GLOBAL_VERSION } from './constants';
import { addRequestId } from './interceptors/RequestId';
import { createRetryWithTokenRefresh } from './interceptors/RefreshToken';
export function getDefaultInterceptor({ ifUnauthorized }, lang) {
    return {
        request: () => (source) => source.pipe(addStartTime(), addSignature(), addRequestId()),
        response: () => (source) => source.pipe(addEndTime(), parseServerTime()),
        error: () => (source) => source.pipe(ifUnauthorized(), catchGDKError(lang))
    };
}
export function getRefreshTokenInterceptor(refreshFn, count = 1) {
    return {
        response: (shouldTrigger) => (source) => source.pipe(createRetryWithTokenRefresh({ shouldTrigger, refreshFn, count }))
    };
}
// eslint-disable-next-line @typescript-eslint/max-params -- no breaking changes
export function createBaseModule(baseURL, timeout, lang, customInterceptor = getDefaultInterceptor, createAdapter) {
    const { ifUnauthorized, isLoginSubject } = createAuthorization();
    const api = createAPIService(baseURL, timeout, GLOBAL_VERSION, customInterceptor({ ifUnauthorized, isLoginSubject }, lang), createAdapter);
    return {
        baseURL,
        timeout,
        api,
        lang,
        error: api.base.errors,
        isLoginSubject
    };
}
//# sourceMappingURL=BaseModule.js.map